import { h } from "omi";

import { IconProps } from "@/wc/components";

export function KeyholeIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} viewBox="0 0 154 292">
      <path
        fill="#1B1918"
        fill-rule="evenodd"
        d="M118.297 160.779c-2.284-10.296 2.71-20.615 10.453-27.776 15.146-14.01 24.629-34.054 24.629-56.313 0-42.355-34.335-76.69-76.69-76.69C34.336 0 0 34.335 0 76.69c0 22.26 9.485 42.306 24.633 56.316 7.743 7.161 12.739 17.481 10.454 27.777L12.473 262.694c-3.325 14.986 8.08 29.199 23.43 29.199h81.579c15.351 0 26.755-14.213 23.43-29.199l-22.615-101.915Z"
        clip-rule="evenodd"
      />
    </svg>
  );
}
